import { useState, useEffect } from "react";
import { useSelector } from "react-redux";
import { initDeliveryMethods } from "../services/checkoutService";
import { isInStoreSelector } from "../selectors/site";
const useDeliveryMethods = cartSpuIds => {
  const [deliveryMethods, setDeliveryMethods] = useState([]);
  const isInStore = useSelector(isInStoreSelector);
  useEffect(() => {
    if (cartSpuIds.length > 0) {
      initDeliveryMethods(cartSpuIds, isInStore).then(methods => {
        setDeliveryMethods(methods);
      });
    } else {
      const list = [
        { label: "Delivery A", deliveryTime: "2 days", formattedPrice: "€10", value: "a" },
        { label: "Delivery B", deliveryTime: "1 day", formattedPrice: "€12", value: "b" }
      ];
      setDeliveryMethods(list);
    }
  }, [cartSpuIds]);
  return deliveryMethods;
};
export default useDeliveryMethods;
